<template>
  <div class="px-2 py-4 max-w-[100vw] overflow-hidden">
    <h3 class="text-xl mb-4 text-center font-['Formula1-Bold']">Big 2 Results</h3>

    <div class="relative overflow-x-auto shadow-md sm:rounded-lg font-['Formula1-Regular'] w-full max-w-full bg-white border border-gray-200">
      <table class="w-full text-xs text-left rtl:text-right text-gray-800">
        
        <thead class="text-xs text-white uppercase bg-[#FF0000]">
          <tr>
            <th scope="col" class="px-3 py-3 cursor-pointer hover:bg-[#d40000] select-none whitespace-nowrap" @click="sortBy('winner')">
              <div class="flex items-center">
                Winner
                <svg class="w-3 h-3 ms-1" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z"/>
                </svg>
              </div>
            </th>
            <th scope="col" class="px-3 py-3 cursor-pointer hover:bg-[#d40000] select-none whitespace-nowrap" @click="sortBy('second')">
              <div class="flex items-center">
                Second
                <svg class="w-3 h-3 ms-1" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z"/>
                </svg>
              </div>
            </th>
            <th scope="col" class="px-3 py-3 cursor-pointer hover:bg-[#d40000] select-none whitespace-nowrap" @click="sortBy('third')">
              <div class="flex items-center">
                Third
                <svg class="w-3 h-3 ms-1" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z"/>
                </svg>
              </div>
            </th>
            <th scope="col" class="px-3 py-3 cursor-pointer hover:bg-[#d40000] select-none whitespace-nowrap" @click="sortBy('loser')">
              <div class="flex items-center">
                Loser
                <svg class="w-3 h-3 ms-1" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z"/>
                </svg>
              </div>
            </th>
            <th scope="col" class="px-3 py-3 cursor-pointer hover:bg-[#d40000] select-none whitespace-nowrap" @click="sortBy('created_at')">
              <div class="flex items-center">
                Datetime
                <svg class="w-3 h-3 ms-1" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z"/>
                </svg>
              </div>
            </th>
            <th scope="col" class="px-3 py-3 cursor-pointer hover:bg-[#d40000] select-none whitespace-nowrap max-w-[150px]" @click="sortBy('location')">
              <div class="flex items-center">
                Location
                <svg class="w-3 h-3 ms-1" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z"/>
                </svg>
              </div>
            </th>
          </tr>
        </thead>
        
        <tbody>
          <tr 
            v-for="dataItem in paginatedData" 
            :key="dataItem.id" 
            class="odd:bg-white even:bg-gray-50 border-b hover:bg-gray-100 text-gray-900"
          >
            <td class="px-3 py-2.5 font-medium">{{ dataItem.winner }}</td>
            <td class="px-3 py-2.5">{{ dataItem.second }}</td>
            <td class="px-3 py-2.5">{{ dataItem.third }}</td>
            <td class="px-3 py-2.5">{{ dataItem.loser }}</td>
            <td class="px-3 py-2.5 whitespace-nowrap">{{ formatDateTime(dataItem.created_at) }}</td>
            <td class="px-3 py-2.5 max-w-[300px] min-w-[200px] break-words">
              {{ dataItem.location }}
            </td>
          </tr>
        </tbody>
      </table>

      <nav class="flex flex-col items-center justify-center p-4 bg-white gap-3 w-full" aria-label="Table navigation">
        <span class="text-xs font-normal text-gray-500 text-center">
          Showing <span class="font-semibold text-gray-900">{{ startIndex + 1 }}-{{ endIndex }}</span> 
          of <span class="font-semibold text-gray-900">{{ totalItems }}</span>
        </span>
        
        <div class="w-full overflow-x-auto flex justify-center pb-1">
          <ul class="inline-flex -space-x-px text-xs h-8 list-none p-0 m-0">
            <li class="m-0 p-0">
              <button @click="prevPage" :disabled="currentPage === 1" class="flex items-center justify-center px-3 h-8 ms-0 leading-tight text-gray-500 bg-white border border-gray-300 rounded-s-lg hover:bg-gray-100 hover:text-gray-700 disabled:opacity-50 disabled:cursor-not-allowed">Prev</button>
            </li>
            
            <li v-for="page in totalPages" :key="page" class="m-0 p-0">
              <button @click="goToPage(page)" :class="['flex items-center justify-center px-3 h-8 leading-tight border border-gray-300', currentPage === page ? 'text-white bg-red-600 border-red-600 hover:bg-red-700 font-bold' : 'text-gray-500 bg-white hover:bg-gray-100 hover:text-gray-700']">{{ page }}</button>
            </li>
            
            <li class="m-0 p-0">
              <button @click="nextPage" :disabled="currentPage === totalPages" class="flex items-center justify-center px-3 h-8 leading-tight text-gray-500 bg-white border border-gray-300 rounded-e-lg hover:bg-gray-100 hover:text-gray-700 disabled:opacity-50 disabled:cursor-not-allowed">Next</button>
            </li>
          </ul>
        </div>
      </nav>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'ResultsPage',
  data() {
    return {
      apiData: [], 
      currentPage: 1,      
      itemsPerPage: 50,
      sortKey: 'created_at',
      sortAsc: false, 
    };
  },
  computed: {
    sortedData() {
      return [...this.apiData].sort((a, b) => {
        let modifier = this.sortAsc ? 1 : -1;
        let aVal = a[this.sortKey] || '';
        let bVal = b[this.sortKey] || '';
        
        if (this.sortKey === 'created_at') {
          aVal = new Date(aVal).getTime();
          bVal = new Date(bVal).getTime();
        } else {
          aVal = aVal.toString().toLowerCase();
          bVal = bVal.toString().toLowerCase();
        }

        if (aVal < bVal) return -1 * modifier;
        if (aVal > bVal) return 1 * modifier;
        return 0;
      });
    },
    totalItems() {
      return this.sortedData.length;
    },
    totalPages() {
      return Math.ceil(this.totalItems / this.itemsPerPage) || 1;
    },
    startIndex() {
      return (this.currentPage - 1) * this.itemsPerPage;
    },
    endIndex() {
      return Math.min(this.startIndex + this.itemsPerPage, this.totalItems);
    },
    paginatedData() {
      return this.sortedData.slice(this.startIndex, this.endIndex);
    }
  },
  methods: {
    formatDateTime(dateTimeString) {
      if (!dateTimeString) return '';
      const dateTime = new Date(dateTimeString);
      const date = dateTime.toLocaleDateString();
      const time = dateTime.toLocaleTimeString();
      return `${date} ${time}`;
    },
    sortBy(key) {
      if (this.sortKey === key) {
        this.sortAsc = !this.sortAsc;
      } else {
        this.sortKey = key;
        this.sortAsc = true;
      }
      this.currentPage = 1;
    },
    nextPage() {
      if (this.currentPage < this.totalPages) this.currentPage++;
    },
    prevPage() {
      if (this.currentPage > 1) this.currentPage--;
    },
    goToPage(page) {
      this.currentPage = page;
    }
  },
  created() {
    document.title = 'Big 2 Results'; 
    axios.get('https://kbcardgames.xyz/api/big2-statistics/')
      .then(response => {
        this.apiData = response.data;
      })
      .catch(error => {
        console.error('Error:', error);
      });
  },
}
</script>

<style scoped>
@font-face {
  font-family: 'Formula1-Regular';
  src: url('@/assets/fonts/Formula1-Regular.otf') format('opentype'); 
}

@font-face {
  font-family: 'Formula1-Bold';
  src: url('@/assets/fonts/Formula1-Bold.otf') format('opentype'); 
}
</style>